import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IPaginationOption } from '../../../interfaces/table/table-pagination-option';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input()
  public set pagination(pagination: IPaginationOption) {
    if (pagination) {
      this.maxPage = Math.ceil(pagination.dataLength / pagination.quantityPerPage);
      if (this.currentPage > this.maxPage) {
        this.currentPage = this.maxPage;
      }
    }
  }

  public maxPage: number;
  public currentPage: number;

  @Output()
  public pageChanged: EventEmitter<number>;

  constructor() {
    this.currentPage = 1;
    this.pageChanged = new EventEmitter();
  }

  /**
   * Function to change page in table
   *
   * @param page new page
   */
  public changeNextPage(page: number): void {
    if (page > this.maxPage) {
      this.currentPage = this.maxPage;
      this.changeNextPage(this.maxPage);
    }
    if (page > 0 && page <= this.maxPage) {
      this.currentPage = +page + 1;
      this.pageChanged.emit(this.currentPage);
    } else {
      // To return the value of input to the current page before change
      this.currentPage = 0;

      if (page < 1) {
        setTimeout(() => (this.currentPage = 1), 0);
      } else if (page > this.maxPage) {
        setTimeout(() => (this.currentPage = this.maxPage), 0);
      }
    }
  }

  /**
   * Function to change page in table
   *
   * @param page new page
   */
  public changePreviousPage(page: number): void {
    if (page > 0 && page <= this.maxPage) {
      this.currentPage = +page - 1;
      this.pageChanged.emit(this.currentPage);
    } else {
      // To return the value of input to the current page before change
      this.currentPage = 0;

      if (page < 1) {
        setTimeout(() => (this.currentPage = 1), 0);
      } else if (page > this.maxPage) {
        setTimeout(() => (this.currentPage = this.maxPage), 0);
      }
    }
  }

  /**
   * Function to change page in table
   * @param page new page
   * @returns void
   */
  public changePage(page: number): void {
    // empty or 0 page will be considered as 1
    if (!page || page <= 0) {
      this.currentPage = 1;
    } else if (page > this.maxPage) {
      // last page redirection
      this.currentPage = this.maxPage;
    } else {
      this.currentPage = page;
    }

    this.pageChanged.emit(this.currentPage);
  }

  /**
   * Function to validate the input of the page number
   * @param event Keyboard event
   * @returns void
   */
  public validateInput(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight']; // Allowed keys
    const { key } = event;

    // Calculate the maximum length of the page number
    const maxLength = this.maxPage.toString().length;

    const inputElement = event.target as HTMLInputElement;

    // Verify if the input is a number and if the length is less than the maximum length
    if (inputElement.value.length >= maxLength && !allowedKeys.includes(key)) {
      event.preventDefault();
      return;
    }

    // allowed keys and numbers
    if (!/^\d$/.test(key) && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  /**
   * Function to adjust the width of the input according to the number of characters
   * @param event Input event
   * @returns void
   */
  public adjustWidth(event: any) {
    const inputElement = event.target;
    inputElement.style.width = `${inputElement.value.length + 3}ch`;
    inputElement.style.paddingRight = '1ch';
    inputElement.style.paddingLeft = '1ch';
  }
}
